import { NavigationButton } from './NavigationButton';
import { themed } from './Navigation.theme';

export const Navigation = themed(({ theme, swiper, arrowColor }) => {
  return (
    <>
      <NavigationButton onClick={() => swiper.slidePrev()} arrowColor={arrowColor} />

      <NavigationButton
        onClick={() => swiper.slideNext()}
        src="/svgs/chevron/right.svg#right"
        alt="Next product"
        isNext
        arrowColor={arrowColor}
      />
    </>
  );
});

Navigation.displayName = 'Navigation';